import {
  faArrowLeft,
  faCheckSquare,
  faCircle,
  faEye,
  faList,
  faSquare,
  faTachometer,
  faTasks,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { camelize } from "humps";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Scroll from "react-scroll";

import { useRecoilState } from "recoil";
import { getReportDetailAPI, putReportUpdateAPI } from "../../../API/Report";
import { topAlertMessageState, topAlertStatusState } from "../../../AppState";
import FormInputField from "../../Reusable/FormInputField";
import FormUnixDateField from "../../Reusable/FormUnixDateField";
import PageLoadingContent from "../../Reusable/PageLoadingContent";

function UserReportDetail() {
  ////
  //// Global state.
  ////

  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);

  ////
  //// URL Parameters.
  ////

  const { uid, rid } = useParams();

  ////
  //// Component states.
  ////

  const [errors, setErrors] = useState({});
  const [report, setReport] = useState({});
  const [selectedVideoSectionForDeletion, setSelectedVideoSectionForDeletion] =
    useState("");
  const [isFetching, setFetching] = useState(false);

  ////
  //// API.
  ////

  function onReportDetailSuccess(response) {
    console.log("onReportDetailSuccess: Starting...");
    setReport(response);
  }

  function onReportDetailError(apiErr) {
    console.log("onReportDetailError: Starting...");
    setErrors(apiErr);

    // The following code will cause the screen to scroll to the top of
    // the page. Please see ``react-scroll`` for more information:
    // https://github.com/fisshy/react-scroll
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onReportDetailDone() {
    console.log("onReportDetailDone: Starting...");
    setFetching(false);
  }

  function onVideoSectionDeleteSuccess(response) {
    console.log("onVideoSectionDeleteSuccess: Starting..."); // For debugging purposes only.

    // Update notification.
    setTopAlertStatus("success");
    setTopAlertMessage("Video section deleted");
    setTimeout(() => {
      console.log(
        "onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    // Fetch again an updated list.
    // fetchList();
  }

  function onVideoSectionDeleteError(apiErr) {
    console.log("onVideoSectionDeleteError: Starting..."); // For debugging purposes only.
    setErrors(apiErr);

    // Update notification.
    setTopAlertStatus("danger");
    setTopAlertMessage("Failed deleting");
    setTimeout(() => {
      console.log(
        "onVideoSectionDeleteError: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    // The following code will cause the screen to scroll to the top of
    // the page. Please see ``react-scroll`` for more information:
    // https://github.com/fisshy/react-scroll
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onVideoSectionDeleteDone() {
    console.log("onVideoSectionDeleteDone: Starting...");
    setFetching(false);
  }

  ////
  //// Event handling.
  ////

  const onSelectVideoSectionForDeletion = (e, videoSection) => {
    console.log("onSelectVideoSectionForDeletion", videoSection);
    setSelectedVideoSectionForDeletion(videoSection);
  };

  const onDeselectVideoSectionForDeletion = (e) => {
    console.log("onDeselectVideoSectionForDeletion");
    setSelectedVideoSectionForDeletion("");
  };

  const onDeleteConfirmButtonClick = (e) => {
    console.log("onDeleteConfirmButtonClick", selectedVideoSectionForDeletion); // For debugging purposes only.

    //
    // The following code will remove the data from the JSON.
    //

    let vsIndex;
    for (let videoSectionIndex in report.videoSections) {
      let vs = report.videoSections[videoSectionIndex];
      if (vs.name === selectedVideoSectionForDeletion.name) {
        vsIndex = videoSectionIndex;
        break;
      }
    }
    console.log("videoSectionIndex:", vsIndex);
    report.videoSections.splice(vsIndex, 1);

    // Remove from state.
    setSelectedVideoSectionForDeletion("");

    // Update the report.
    console.log("onSubmitClick, report:", report);
    putReportUpdateAPI(
      report,
      onReportUpdateSuccess,
      onReportUpdateError,
      onReportUpdateDone
    );
  };

  function onReportUpdateSuccess(response) {
    // For debugging purposes only.
    console.log("onReportUpdateSuccess: Starting...");
    console.log(response);

    // Add a temporary banner message in the app and then clear itself after 2 seconds.
    setTopAlertMessage("Report updated");
    setTopAlertStatus("success");
    setTimeout(() => {
      console.log("onReportUpdateSuccess: Delayed for 2 seconds.");
      console.log(
        "onReportUpdateSuccess: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);
  }

  function onReportUpdateError(apiErr) {
    console.log("onReportUpdateError: Starting...");
    setErrors(apiErr);

    // Add a temporary banner message in the app and then clear itself after 2 seconds.
    setTopAlertMessage("Failed submitting");
    setTopAlertStatus("danger");
    setTimeout(() => {
      console.log("onReportUpdateError: Delayed for 2 seconds.");
      console.log(
        "onReportUpdateError: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    // The following code will cause the screen to scroll to the top of
    // the page. Please see ``react-scroll`` for more information:
    // https://github.com/fisshy/react-scroll
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onReportUpdateDone() {
    console.log("onReportUpdateDone: Starting...");
    setFetching(false);
  }

  ////
  //// Misc.
  ////

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0); // Start the page at the top of the page.

      setFetching(true);
      getReportDetailAPI(
        rid,
        onReportDetailSuccess,
        onReportDetailError,
        onReportDetailDone
      );
    }

    return () => {
      mounted = false;
    };
  }, [rid]);

  ////
  //// Component rendering.
  ////

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Users
                </Link>
              </li>
              <li class="">
                <Link to={`/user/${uid}/reports`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Detail (Reports)
                </Link>
              </li>
              <li class="is-active">
                <Link aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faTasks} />
                  &nbsp;Report
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/user/${uid}/reports`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Detail (Reports)
                </Link>
              </li>
            </ul>
          </nav>

          {/* Modals */}
          <nav class="">
            <div
              class={`modal ${
                selectedVideoSectionForDeletion ? "is-active" : ""
              }`}
            >
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Are you sure?</p>
                  <button
                    class="delete"
                    aria-label="close"
                    onClick={onDeselectVideoSectionForDeletion}
                  ></button>
                </header>
                <section class="modal-card-body">
                  You are about to delete this video section and all the data
                  inside of it. This action is cannot be undone. Are you sure
                  you would like to continue?
                </section>
                <footer class="modal-card-foot">
                  <button
                    class="button is-success"
                    onClick={onDeleteConfirmButtonClick}
                  >
                    Confirm
                  </button>
                  <button
                    class="button"
                    onClick={onDeselectVideoSectionForDeletion}
                  >
                    Cancel
                  </button>
                </footer>
              </div>
            </div>
          </nav>
          <nav class="box">
            <p class="title is-4">
              <FontAwesomeIcon className="fas" icon={faTasks} />
              &nbsp;Report{" "}
            </p>

            <div class="tabs is-medium">
              <ul>
                <li>
                  <Link class="is-active" to={`/user/${uid}/report/${rid}`}>
                    <strong>Detail</strong>
                  </Link>
                </li>
                {/*
                                <li>
                                    <Link to={`/user/${uid}/report/${rid}/answers`}>Answers</Link>
                                </li>
                                */}
              </ul>
            </div>

            {isFetching ? (
              <PageLoadingContent displayMessage={"Please wait"} />
            ) : (
              <>
                {report !== undefined && report !== null && report !== "" && (
                  <>
                    {report.answers !== undefined &&
                      report.answers !== null &&
                      report.answers !== "" && (
                        <div class="columns">
                          <div class="column" key={report.id}>
                            <p class="subtitle">
                              <FontAwesomeIcon className="fas" icon={faEye} />
                              &nbsp;Detail
                            </p>
                            <FormInputField
                              label="ID"
                              name="id"
                              placeholder="Text input"
                              value={report.id}
                              maxWidth="260px"
                              disabled={true}
                            />

                            <FormUnixDateField
                              label="Created"
                              name="created"
                              type="number"
                              placeholder="0 or 1"
                              value={report.created}
                              maxWidth="120px"
                              disabled={true}
                            />

                            <p class="subtitle">
                              <FontAwesomeIcon className="fas" icon={faList} />
                              &nbsp;Question / Answers
                            </p>
                            <RenderQuestionAnswerDetail
                              questions={report.answers.questions}
                              answers={report.answers.answers}
                            />

                            <div class="columns mt-4">
                              <div class="column is-half">
                                <Link
                                  to={`/user/${uid}/reports`}
                                  class="button is-fullwidth-mobile"
                                >
                                  <FontAwesomeIcon
                                    className="fas"
                                    icon={faArrowLeft}
                                  />
                                  &nbsp;Back to User
                                </Link>
                              </div>
                              <div class="column is-half has-text-right">
                                {/*
                                                    <Link to={`/user/${uid}/report/${rid}/edit`} class="button is-primary is-hidden-touch"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Edit</Link>
                                                    <Link to={`/user/${uid}/report/${rid}/edit`} class="button is-primary is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Edit</Link>
                                                    */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

// The purpose of this component is to render the GUI based on the Rhea Core
// data structure.
function RenderQuestionAnswerDetail({ questions, answers }) {
  // // For debugging purpose only.
  // console.log("questions--->", questions);
  // console.log("answers--->", answers);

  // Extract all the map keys and sort them in ascending order.
  let questionMapKeys = [];
  for (let questionMapKey in questions) {
    questionMapKeys.push(questionMapKey);
  }

  // Sort the map keys.
  const sortedQuestionMapKeys = questionMapKeys.sort((a, b) => {
    const stageNumberA = parseInt(a.match(/\d+/)[0]);
    const stageNumberB = parseInt(b.match(/\d+/)[0]);
    return stageNumberA - stageNumberB;
  });

  return (
    <>
      {sortedQuestionMapKeys.map((questionMapKey, i) => (
        <QuestionAnswer
          questionMapKey={questionMapKey}
          question={questions[questionMapKey]}
          answer={answers[questionMapKey]}
        />
      ))}
    </>
  );
}

function QuestionAnswer({ questionMapKey, question, answer }) {
  // console.log("questionMapKey -->", questionMapKey);
  // console.log("question -->", question);
  // console.log("answer -->", answer);
  // console.log("");
  return (
    <>
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {question.no}.&nbsp;{question.title}
          </p>
          <button class="card-header-icon" aria-label="more options">
            <span class="icon">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </header>
        <div class="card-content">
          <div class="content">
            <h1>{question.secondaryTitle}</h1>

            {answer !== undefined && answer !== null && answer !== "" && (
              <>
                {/* CASE 1 OF 3: Measurements. */}
                {question.measures !== undefined && (
                  <QuestionAnswerMeasurement
                    question={question}
                    answer={answer}
                  />
                )}

                {/* CASE 2 OF 3: Options */}
                {question.options !== undefined && (
                  <p>
                    <QuestionAnswerOption question={question} answer={answer} />
                  </p>
                )}

                {/* CASE 3 OF 3: Null - do nothing here. */}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function QuestionAnswerMeasurement({ question, answer }) {
  // For debugging purposes only.
  // console.log("question -->", question);
  // console.log("answer -->", answer);
  // console.log("");

  return (
    <>
      {question.measures &&
        question.measures.map((measure, i) => {
          // Extract the question key
          let questionMeasureID = camelize(measure.id);

          // Extract the answer key.
          let answerBool = answer[questionMeasureID];

          // // For debugging purposes only.
          // console.log("questionMeasureID", questionMeasureID);
          // console.log("answerBool", answerBool);

          return (
            <>
              <p>
                {answerBool === 1 ? (
                  <span class="">
                    <FontAwesomeIcon className="fas" icon={faCheckSquare} />
                    &nbsp;{measure.label}
                  </span>
                ) : (
                  <span class="has-text-grey-lighter">
                    <FontAwesomeIcon className="fas" icon={faSquare} />
                    &nbsp;{measure.label}
                  </span>
                )}
              </p>
            </>
          );
        })}
    </>
  );
}

function QuestionAnswerOption({ question, answer }) {
  // // For debugging purposes only.
  // console.log("question -->", question);
  // console.log("answer -->", answer);
  // console.log("");

  // Extract all the map keys and sort them in ascending order.
  let answerMapKeys = [];
  for (let answerMapKey in answer) {
    answerMapKeys.push(answerMapKey);
  }

  // // Sort the map keys.
  // const sortedQuestionMapKeys = questionMapKeys.sort((a, b) => {
  //     const stageNumberA = parseInt(a.match(/\d+/)[0]);
  //     const stageNumberB = parseInt(b.match(/\d+/)[0]);
  //     return stageNumberA - stageNumberB;
  // });

  let pickedOptions = [];
  for (let opt of question.options) {
    for (let answerMapKey of answer) {
      // for debugging purposes only.
      // console.log("opt                --->", opt);
      // console.log("opt.id             --->", opt.id);
      // console.log("answerMapKey    ------>", answerMapKey);
      if (opt.id === answerMapKey) {
        pickedOptions.push(opt);
      }
    }
  }

  return (
    <>
      {pickedOptions &&
        pickedOptions.map(function (opt, i) {
          return (
            <div class="pb-2 mb-4">
              <span class="">
                <FontAwesomeIcon className="fas" icon={faCircle} />
                &nbsp;{opt.label}
              </span>
            </div>
          );
        })}
    </>
  );
}

export default UserReportDetail;
